/** @copyright (c) Viewpost. All Rights Reserved. See LICENSE for more details. */

import React from 'react';
import PathLink from 'components/Link/PathLink';
import Logo from 'components/Logo';
import Paths from 'config/paths';

export const useRootPath = () => {
  return Paths.Dashboard;
};

const LogoLink = ({
  height = 21,
  width = 108,
  variant
}) => {
  const rootPath = useRootPath();

  return (
    <PathLink
      path={rootPath}
      className="logo"
      activeClassName={variant === 'vp' || variant === 'ignoreHighlight'
        ? null
        : 'active navCaret noSecNav'}
    >
      <Logo
        height={height || 21}
        width={width || 108}
        variant={variant}
      />
    </PathLink>
  );
};

export default LogoLink;